import { jsx } from "react/jsx-runtime";
import react from "react";
import { ConfigProvider } from "./context/ConfigProvider.js";
import { PclnUcChatBot } from "./PclnUcChatBot.js";
const TheChatBot = /*#__PURE__*/ react.memo((props)=>{
    const propDrill = {
        componentVersion: props.componentVersion,
        discoveryCitySelected: props.discoveryCitySelected,
        handleMarkerResponse: props.handleMarkerResponse,
        isChatBoxOpened: props.isChatBoxOpened,
        markerComponents: props.markerComponents,
        onChatDialogRendered: props.onChatDialogRendered,
        onClose: props.onClose,
        realtimeContext: props.realtimeContext
    };
    return /*#__PURE__*/ jsx(ConfigProvider, {
        customerName: props.customerName,
        isChatBoxOpened: props.isChatBoxOpened,
        locale: props.locale,
        viewType: props.viewType,
        webstats: props.webstats,
        startingChatMessagesPayload: props.startingChatMessagesPayload,
        logAnalytics: props.logAnalytics,
        children: (resolvedConfig, resolvedDisplay, resolvedFeatures, resolvedPayload, chatbotFeatures)=>/*#__PURE__*/ jsx(PclnUcChatBot, {
                resolvedFeatures: resolvedFeatures,
                resolvedConfig: resolvedConfig,
                resolvedDisplay: resolvedDisplay,
                resolvedPayload: resolvedPayload,
                chatbotFeatures: chatbotFeatures,
                ...propDrill
            })
    });
});
export { TheChatBot };
